import { motion } from "framer-motion";
import { BreathingVisualizer } from "../components/BreathingVisualizer";
import { AmbientSoundToggle } from "../components/AmbientSoundToggle";
import { StepHeader } from "../components/StepHeader";
import { ProgressBar } from "../components/ProgressBar";
import { useFunnel } from "../context/FunnelContext";

export default function ThankYouPage() {
  const { answers } = useFunnel();
  const firstName = (answers.visitor_name || "").trim().split(" ")[0];

  return (
    <motion.main
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.35 }}
      data-testid="thank-you-page"
      className="min-h-screen px-6 py-28 bg-[#FBF9F5] flex items-center justify-center"
    >
      <ProgressBar step={6} total={6} />
      <div className="max-w-xl w-full text-center">
        <StepHeader step={6} total={6} label="You're All Set" />
        {firstName && (
          <p className="text-sm uppercase tracking-[0.25em] font-semibold text-[#C47B5E]/80 mb-3" data-testid="visitor-welcome-note">
            Welcome, {firstName}
          </p>
        )}
        <h1 className="font-serif text-3xl sm:text-4xl text-[#1E2D24] mb-4">
          {firstName ? `Thank you, ${firstName}, for honouring your inner self.` : "Thank you for honouring your inner self."}
        </h1>
        <p className="text-[#5F6A62] text-base sm:text-lg leading-relaxed mb-10">
          Booking this call is a courageous, loving act toward yourself. You'll receive a confirmation
          email shortly with all the details. Bring any questions, fears, or nothing at all — everything
          is welcome.
        </p>
        <div className="flex flex-col items-center gap-6 mb-10">
          <BreathingVisualizer />
          <AmbientSoundToggle />
        </div>
        <p className="text-sm text-[#5F6A62]/80 italic max-w-md mx-auto">
          Before our call, you might like to take 5 minutes to breathe, journal, or simply notice how you
          feel. There is no right or wrong way to show up.
        </p>
      </div>
    </motion.main>
  );
}
